export const colors = {
  button: '#d500f9',
  iconButton: '#e6e6e6',
  buttonText: '',
  heading: '',
  subHeading: '',
  background: '',
}
